export const API_DATA = 'API_DATA';

export const dataConstants = {
  API_DATA: 'API_DATA',
  API_DATA_REQUEST: 'API_DATA_REQUEST',
  API_DATA_SUCCESS: 'API_DATA_SUCCESS',
  API_DATA_FAILED: 'API_DATA_FAILED',
};
